
export default class Payload {		
	static createPayload(clientId, role, testerIdentifier, messageName, eventType, message) {
		let payload;
		if (message) {			
			 payload = Object.assign({}, message);
		}else{
			 payload = Object.create(new this());
		}
		payload.clientId = clientId;
		payload.senderType = role;
		payload.testerIdentifier = testerIdentifier;
		payload.eventType = eventType;
		payload.messageName = messageName;
		payload.jsonTimestamp = (new Date()).toJSON();
		return payload;
	}
}